export enum AdsPlacement {
  FinderHorizontal = 1,
  FinderVertical = 2,
  Threads = 3,
  Chat = 4,
  Interstitial = 5,
  ClickUnder = 6,
  PopUnder = 7,
  FloatingBubble = 8,
  AdVideoPopup = 9,
  PicInPic = 10,
  NotificationsHorizontal = 11,
  FinderDoubleVertical = 16,
  MyProfileHorizontal = 17,
}
